import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TermsURL } from '@core/models/terms-of-service.interface';
import { TermsOfServiceService } from '@core/services/termsOfService/terms-of-service.service';
import { UiButtonComponent } from '@shared/components/ui-elements/ui-button/ui-button.component';
import { UiSkeletonLoaderComponent } from '@shared/components/ui-elements/ui-skeleton-loader/ui-skeleton-loader.component';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'authentication-terms-register-dialogs',
  templateUrl: './authentication-terms-register-dialogs.component.html',
  styleUrls: ['./authentication-terms-register-dialogs.component.scss'],
  standalone: true,
  imports: [
    UiButtonComponent,
    CommonModule,
    MatDialogModule,
    MatToolbarModule,
    UiSkeletonLoaderComponent,
    TranslatePipe,
  ],
})
export class AuthenticationTermsRegisterDialogsComponent implements OnInit {

  isLoading = false;
  isLoadingIcon = false;
  termsData= '';

  constructor(
    private dialogRef: MatDialogRef<AuthenticationTermsRegisterDialogsComponent>,
    private termsOfService: TermsOfServiceService,
    @Inject(MAT_DIALOG_DATA) public data: TermsURL,
  ) {    
    if (data && data.url) {
      this.isLoading = true;      
      this.termsOfService.getTermsData(data.url).subscribe({
        next: (res: string) => {
          this.termsData = res;
          this.isLoading = false;
        },
      });
    }
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    setTimeout(() => {    
      this.isLoadingIcon=true
    }, 2000);
  }

  onAgreeButtonClick() {
    this.isLoading = true;
    this.dialogRef.disableClose = true;
    this.dialogRef.close();
    this.dialogRef.close('save');
  }

}